import { useQuery } from '@tanstack/react-query'

import { ChecklistTask } from '@/models/features/checklist.models'

import { authAPI } from '../new-api'

// Note: checklist can be of type 'task' or 'inspection'.
// This endpoint should be used to get the details of a checklist task.
// but temporarily it can also return the details of an inspection.
export interface GetChecklistTaskDetailsRequest {
  checklistId?: string
}

export const GET_CHECKLIST_TASK_DETAILS_BASE_QUERY_KEY = 'useGetChecklistTaskDetails'

export const getChecklistTaskDetailsQueryKey = (data: GetChecklistTaskDetailsRequest) => [
  GET_CHECKLIST_TASK_DETAILS_BASE_QUERY_KEY,
  data,
]

export const getChecklistTaskDetails = async (data: GetChecklistTaskDetailsRequest) => {
  const { checklistId } = data

  const response = await authAPI.get<ChecklistTask>(`/checklist-unified/detail/${checklistId}`)
  return response.data
}

export const useGetChecklistTaskDetails = (data: GetChecklistTaskDetailsRequest) => {
  return useQuery({
    enabled: !!data.checklistId,
    queryFn: () => getChecklistTaskDetails(data),
    queryKey: getChecklistTaskDetailsQueryKey(data),
  })
}
